// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"8f549fc9","86":"5ad66ee3","223":"9bae8623","455":"5c2453c6","478":"62ee19b1","498":"f6afde7b","583":"d2933157","630":"15d98907","701":"50e8ed67","895":"693c4279"}[chunkId] + ".chunk.js";
};